'use client'

import { PaginatedDocs } from 'payload'
import { Card, CardProps } from '@/ui/components/Card'
import { TrackableCard } from '@/ui/components/Card/TrackableCard'
import { CardType } from '@/ui/components/Card/types'
import { ItemsGridSkeleton } from '@/ui/components/CollectionArchive/ArchiveContent/ItemsGrid/ItemsGridSkeleton'
import { cn } from '@/utils/ui'
import { getGridColumnClass } from '@/ui/components/CollectionArchive/ArchiveContent/ItemsGrid'
import React from 'react'

export const ArchiveContent = ({
  items,
  isLoading,
  gridCols,
  cardType,
  limit = 10,
  enableTracking = false,
  userId,
  showImage,
}: {
  items: PaginatedDocs<CardProps>
  isLoading: boolean
  gridCols: 1 | 2 | 3 | 4
  cardType: CardType
  limit?: number
  enableTracking?: boolean
  userId?: string
  showImage?: boolean
}) => {
  return (
    <div className="@container/grid">
      {isLoading ? (
        <ItemsGridSkeleton gridCols={gridCols} limit={limit} cardType={cardType} showImage={showImage} />
      ) : (
        <div className={cn('grid', getGridColumnClass(gridCols))}>
          {items.docs.map((doc, index) => {
            // Determine if this card should be tracked
            const shouldTrack = enableTracking && userId
            const itemId = 'favItemId' in doc ? String(doc.favItemId) : undefined
            const collection = 'collection' in doc ? doc.collection : undefined
            const itemType =
              collection === 'products' ? 'product' : collection === 'solutions' ? 'solution' : undefined

            return (
              <React.Fragment key={index}>
                {shouldTrack && itemId && itemType ? (
                  <TrackableCard
                    {...doc}
                    className="h-full"
                    userId={userId}
                    itemId={itemId}
                    itemType={itemType}
                    enableTracking={true}
                  />
                ) : (
                  <Card {...doc} className="h-full" />
                )}
              </React.Fragment>
            )
          })}
        </div>
      )}
    </div>
  )
}
